import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";
import { Select, InputLabel, FormControl, MenuItem, TableContainer,
  TableBody, TableHead, TableRow, TableCell, Card,  Dialog,
  DialogTitle,
  DialogContent, Grid,
  TextField,
  DialogActions,Menu, ListItemIcon, ListItemText,
  Table,  Paper, Box,Typography, CircularProgress ,Button} from "@mui/material";
import { useParams,useNavigate } from "react-router-dom";
import {IconButton} from '@mui/material'
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { borderRadius, width } from "@mui/system";
import { GlobalStyles } from "@mui/system";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';


const baseUrl = process.env.REACT_APP_API_BASE_URL;

const SoldItems = () => {
     const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [saveditems, setSavedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsloading, setItemsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitFinalLoading, setSubmitFinalLoading] = useState(false);
  const { studentId } = useParams();
  const { oId, userId, role ,board,pId} = useAuth();
  // const [users, setUsers] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dateRangeFromQuery = queryParams.get('dateRange');

  const [selectedDate, setSelectedDate] = useState(dateRangeFromQuery || "currentMonth");
  const [openCustomDialog, setOpenCustomDialog] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;


  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };



    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/STORE_DEPARTMENT/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount


    // Handle date filter change
    const handleDateChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedDate(selectedValue);
        ///dateFilter===selectedValue
        if (selectedValue === "customDate") {
          setOpenCustomDialog(true); // Open custom date selection dialog
        }
      };

      const handleGetButtonClick = () => {
        if (startDate && endDate) {
          console.log("Fetching data for:", startDate, endDate);
          setSelectedDate("customDate"); // This updates UI but doesn't fetch data
          fetchSoldItemsData(); // Manually fetch data only when clicking "Get"
          setOpenCustomDialog(false);
        } else {
          console.error("Start Date or End Date is missing");
        }
      };
      
      
      
      // Fetch all expenses list based on date range
      const fetchSoldItemsData = async () => {
        if (!oId || !UserId) {
          console.warn("Missing required parameters to fetch data.");
          setItemsLoading(false);
          return;
        }
      
        setItemsLoading(true);
        try {
          let endpoint = "";
          const today = new Date();
          const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
      
          switch (selectedDate) {
            case "today":
              endpoint = `${baseUrl}/api/soldItems/store/getTodaySoldItems/today/${formattedDate}/${oId}/${UserId}`;
              break;
      
            case "yesterday":
              endpoint = `${baseUrl}/api/soldItems/store/getYesterdaySoldItems/yesterday/${formattedDate}/${oId}/${UserId}`;
              break;
      
            case "lastWeek":
              endpoint = `${baseUrl}/api/soldItems/store/getLastWeekSoldItems/lastweek/${formattedDate}/${oId}/${UserId}`;
              break;
      
            case "currentMonth":
              endpoint = `${baseUrl}/api/soldItems/store/getCurrentMonthSoldItems/currentmonth/${formattedDate}/${oId}/${UserId}`;
              break;
            case "lastSixMonths":
              endpoint = `${baseUrl}/api/soldItems/store/getLastSixMonthsSoldItems/lastsixmonths/${formattedDate}/${oId}/${UserId}`;
              break;
            case "currentAcademicYear":
              endpoint = `${baseUrl}/api/soldItems/store/getAcademicYearSoldItems/academicyear/${formattedDate}/${oId}/${UserId}`;
              break;                
      

      
            default:
              endpoint = `${baseUrl}/api/soldItems/store/getCurrentMonthSoldItems/currentmonth/${formattedDate}/${oId}/${UserId}`;
              break;
          }
      
          const response = await fetch(endpoint);
          if (!response.ok) {
            // throw new Error('Failed to fetch users');
            console.log(`Failed to fetch data: ${response.status}`)
        }
          // if (!response.ok) throw new Error(`Failed to fetch data: ${response.status}`);
      
          const data = await response.json();
          setSavedItems(data);

          // Extract unique categories
          const uniqueCategories = [
            ...new Set(data.map((item) => item.category)),
          ];
          setCategoryOptions(uniqueCategories);

      
        } catch (error) {
          console.error("Error fetching expenses data:", error);
          setSavedItems([]);
        } finally {
          setItemsLoading(false);
        }
      };
      
      // Automatically fetch when dependencies change
      useEffect(() => {
        fetchSoldItemsData();
      }, [selectedDate,oId,UserId]);




  //search functionality
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const filteredItems = saveditems.filter(
    (item) =>
      (
        item.items?.join(", ").toLowerCase().includes(searchQuery.toLowerCase())
      ) &&
      (selectedCategory ? item.category === selectedCategory : true)
  );
  
  
  






// Export to Excel
const exportToExcel = () => {
  const processedData = filteredItems.map(
    (
      {
        date,
        billNo,
        studentId,
        studentFirstName,
        studentLastName,
        romanNumberClass,
        sections,
        items,
        billAmount,
      },
      index
    ) => ({
      Date: date,
      BillNo: billNo,
      StudentId: studentId,
      StudentName: `${studentFirstName} ${studentLastName}`,
      Class: romanNumberClass,
      Section: sections,
      Items: Array.isArray(items) ? items.join(", ") : items,
      TotalBillAmount: billAmount,
    })
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sold_Items");

  worksheet.columns = [
    { header: "Date", key: "Date", width: 15 },
    { header: "Bill No", key: "BillNo", width: 25 },
    { header: "Student Id", key: "StudentId", width: 20 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Class", key: "Class", width: 15 },
    { header: "Section", key: "Section", width: 15 },
    { header: "Items", key: "Items", width: 30 },
    { header: "Total Bill Amount", key: "TotalBillAmount", width: 20 },
  ];

  processedData.forEach((data) => {
    worksheet.addRow(data);
  });

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue
    };
  });

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Sold_Items_List.xlsx`;
    link.click();
  });

  handleExportClose();
};

      // Export to PDF
      const exportToPDF = () => {
        const doc = new jsPDF();
      
        // Title
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Sold Items Report", 10, 8);
      
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text("Generated On: ", 14, 16);
        doc.setFont("helvetica", "bold");
        doc.text(new Date().toLocaleDateString(), 40, 16);
      
        // Table
        doc.autoTable({
          startY: 20,
          head: [
            [
              "S.No",
              "Date",
              "Bill No",
              "Student Id",
              "Student Name",
              "Class",
              "Section",
              "Items",
              "Total Amount",
            ],
          ],
          body: filteredItems.map((item, index) => [
            index + 1,
            item.date,
            item.billNo,
            item.studentId,
            `${item.studentFirstName} ${item.studentLastName}`,
            item.romanNumberClass,
            item.sections,
            Array.isArray(item.items) ? item.items.join(", ") : item.items,
            item.billAmount,
          ]),
          styles: {
            lineWidth: 0.2,
            lineColor: "#B6B9CD",
          },
          headStyles: {
            fillColor: [63, 81, 181], // Dark blue
            textColor: [255, 255, 255],
            halign: "center",
          },
          bodyStyles: {
            halign: "center",
          },
          theme: "grid",
        });
      
        doc.save("Sold_Items_Report.pdf");
        handleExportClose();
      };
      
      const exportToJSON = () => {
        const processedData = filteredItems.map((item) => ({
          Date: item.date,
          BillNo: item.billNo,
          StudentId: item.studentId,
          StudentName: `${item.studentFirstName} ${item.studentLastName}`,
          Class: item.romanNumberClass,
          Section: item.sections,
          Items: Array.isArray(item.items) ? item.items.join(", ") : item.items,
          TotalBillAmount: item.billAmount,
        }));
      
        const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
          JSON.stringify(processedData, null, 2)
        )}`;
        const link = document.createElement("a");
        link.href = jsonString;
        link.download = `Sold_Items_List.json`;
        link.click();
        handleExportClose();
      };

      







  
  const styles = {
    container: {
        minHeight: "80vh",
        backgroundColor: "#f3f4f6",
        // display: "flex",
        // justifyContent: "center",
        padding: "5% 10px", // equal padding left & right
        
      },
     
      
    heading: {
      fontSize: "20px",
      fontWeight: "700",
      color: "#1f2937",
      marginBottom: "20px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
    backArrow: {
      fontSize: "24px",
      cursor: "pointer",
      color: "#2563eb",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
        border: "1px solid #ddd", // ✅ Full border
        padding: "5px",
        backgroundColor: "#fff9c4",
        textAlign: "center",
        fontWeight: "bold",
      },
      
      td: {
        border: "1px solid #ddd", // ✅ Full border
        padding: "8px",
        textAlign: "center",
      },
    checkbox: {
      width: "16px",
      height: "16px",
      borderRight: "1px solid #ddd",
      borderBottom: "1px solid #ddd", // ✅ Add this
      padding: "8px",
      textAlign: "center",
      cursor: "pointer",
    },
    loading: {
      textAlign: "center",
      padding: "40px",
      fontSize: "16px",
      color: "#6b7280",
    },
    button: {
      marginTop: "24px",
      padding: "12px 24px",
      backgroundColor: "#3C3972",
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
    },
    buttonDisabled: {
      backgroundColor: "#9ca3af",
      cursor: "not-allowed",
    },
  };
  

  return (
    
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      sx={{
        marginTop: "60px",
        width: "100%",
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        padding: "20px",
      }}
    >
     
        {/* Heading with arrow */}
        <div style={styles.heading}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
         
          <Typography variant="h4" style={{ fontWeight: "bold", color: "#333" }}>
            {dateRangeFromQuery
              ? `${dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1)} Sold Items List`
              : "Sold Items List"}
          </Typography>
        </div>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  {/* Left Side - Date and User Select */}
  <Box display="flex" gap={2}>
    {/* Select Date */}
    <FormControl variant="outlined" size="small" sx={{ minWidth: 190 }}>
      <InputLabel id="date-select-label">Select DateRange</InputLabel>
      <Select
        value={selectedDate}
        onChange={handleDateChange}
        label="Select DateRange"
      >
        <MenuItem value="today">Today</MenuItem>
        <MenuItem value="yesterday">Yesterday</MenuItem>
        <MenuItem value="lastWeek">Last Week</MenuItem>
        <MenuItem value="currentMonth">Current Month</MenuItem>
        <MenuItem value="lastSixMonths">LastSix Months</MenuItem>
        <MenuItem value="currentAcademicYear">Academic Year</MenuItem>
        {/* <MenuItem value="customDate">Custom Date</MenuItem> */}
      </Select>
    </FormControl>

    {/* User Select for Principal */}
    {/* {isPrincipal && (
      <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Select User</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select User"
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )} */}

    <TextField
          label="Search Items"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={handleSearchChange}
        />
        
         {/* {isPrincipal && (
                                                  <FormControl fullWidth style={{ width: "150px" }} size="small">
                                                    <InputLabel>Select Admin</InputLabel>
                                                    <Select
                                                      value={selectedUsers}
                                                      onChange={(e) => setSelectedUsers(e.target.value)}
                                                      label="Select Admin"
                                                    >
                                                      {users.map((user) => (
                                                        <MenuItem key={user.userId} value={user.userId}>
                                                          {user.userId}-{user.firstName} {user.lastName}
                                                        </MenuItem>
                                                      ))}
                                                    </Select>
                                                  </FormControl>
                                                )} */}
        {/* <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Select Category</InputLabel>
          <Select
            label="Select Category"
            value={selectedCategory}
            onChange={handleCategoryChange}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {categoryOptions.map((category, index) => (
              <MenuItem key={index} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
  </Box>

  {/* Right Side - Export Button */}
  <Button
    variant="contained"
    onClick={handleExportClick}
    startIcon={<PresentToAllIcon />}
    style={{ backgroundColor: "#3C3972", fontWeight: "bold", height: "40px" }}
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem>
  </Menu>


</Box>



        {/* Table with conditional rendering for loading state */}
        <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />



       


<div style={{ marginTop: "10px" }}>
  
        <TableContainer  component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "350px",
              overflow: "auto",
              marginTop: "10px",
            }}
            className="custom-sidebar-scrollbar">
  <Table stickyHeader>
    <TableHead >
      <TableRow>
        <TableCell style={styles.th}>Sl.No</TableCell>
        
        {/* <TableCell style={styles.th}>Admission No</TableCell> */}
        <TableCell style={styles.th}>Date</TableCell>
        <TableCell style={styles.th}>Bill No</TableCell>
        {/* <TableCell style={styles.th}>Student Id</TableCell> */}
        <TableCell style={styles.th}>Student Name</TableCell>
        {(board === "INTERMEDIATE" ) && (
         <TableCell style={styles.th}>Course</TableCell>
         )}
        <TableCell style={styles.th}>
        {board === "INTERMEDIATE" ? "Year" : "Class"}
          </TableCell>
        <TableCell style={styles.th}>Section</TableCell>
        <TableCell style={styles.th}>Items</TableCell>
        <TableCell style={{...styles.th}}>Total Bill Amount</TableCell>
        {/* ,width: 150 */}
        <TableCell style={styles.th}>Action</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {itemsloading ? (
        <TableRow>
                             <TableCell
                                colSpan={10}
                                style={{ textAlign: "center", padding: "20px" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  <CircularProgress />
                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                    Loading Data...
                                  </Typography>
                                </Box>
                              </TableCell>
        </TableRow>
      ) : filteredItems.length === 0 ? (
        <TableRow>
          <TableCell colSpan="10" style={{ textAlign: "center" }}>
            No data Found
          </TableCell>
        </TableRow>
      ) : (
        filteredItems.map((item,index) => (
          <TableRow key={item.itId}
          style={{
            backgroundColor: "white",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white"; // Default color
          }}
          >
            <TableCell style={styles.td}>{index+1}</TableCell>
            <TableCell style={styles.td}>{item.date}</TableCell>
            <TableCell style={styles.td}>{item.billNo}</TableCell>
            {/* <TableCell style={styles.td}>{item.studentId}</TableCell> */}
            
            
             <TableCell
                                    sx={{
                                      borderRight: "1px solid #ddd",
                                      padding: "4px",
                                      textAlign: "center",
                                    }}
                                  >{`${item.studentFirstName} ${item.studentLastName}`}</TableCell>

                                  {(board === "INTERMEDIATE" ) && (
                                    <TableCell sx={{
                                      borderRight: "1px solid #ddd",
                                      padding: "3px",
                                      textAlign: "center",
                                    }}>
                                      {item.course}
                                      </TableCell>
                                    )}

                              <TableCell
                                    sx={{
                                      borderRight: "1px solid #ddd",
                                      padding: "3px",
                                      textAlign: "center",
                                    }}
                                  >
                                   {item.romanNumberClass}
                                  </TableCell>
            <TableCell style={styles.td}>{item.sections}</TableCell>
            <TableCell style={styles.td}>{item.items.join(", ")}</TableCell>
            <TableCell style={styles.td}>₹{item.billAmount}</TableCell>
            <TableCell
              sx={{
                ...styles.td, // your defined table cell style
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Button
  type="button"
  onClick={() =>
    navigate(`/SoldItemsTemplate/${item.billNo}`, {
      state: { soldItemData: item }
    })
  }
  sx={{
    backgroundColor: "#1976d2",
    color: "white",
    fontSize: "0.6rem",
    height: "25px",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  }}
>
  View
</Button>

            </TableCell>

          </TableRow>
        ))
      )}
    </TableBody>
  </Table>
  </TableContainer>


  </div>



 {/* Custom Date Dialog code */}
        
 {/* <Dialog open={openCustomDialog} onClose={() => setOpenCustomDialog(false)}>
            <DialogTitle sx={{fontWeight:'bold',fontSize:'15px'}}>Select Custom Date Range</DialogTitle>
            <DialogContent>
              <div style={{ display: "flex", gap: "16px" ,marginTop:'10px'}}>
                <TextField
                  label="Start Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  fullWidth
                />
                <TextField
                  label="End Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  fullWidth
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenCustomDialog(false)} variant="outlined" sx={{width:'5px'}}>Cancel</Button>
              <Button
                onClick={() => {
                  if (startDate && endDate) {
                    handleGetButtonClick();
                  } else {
                    alert("Please select both Start Date and End Date.");
                  }
                }}
              sx={{backgroundColor: "#3C3972",color: "#fff", "&:hover": { backgroundColor: "#3C3972" }}}
                variant="outlined"
              >
                Apply
              </Button>
            </DialogActions>
          </Dialog> */}




      </Card>
    </Box>
  
  );
};

export default SoldItems;